var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.285,
    x2: 21.049,
    y1: 7.131,
    y2: 16.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#009ada",
    d: "M17.501 5h-7.5c-.567 0-1.286.245-1.492 1.413C8.483 6.555 6 22.637 6 23c0 .57.43 1 1 1h5.5a.5.5 0 0 0 .494-.418l.93-5.582H15.5C19.636 18 23 14.636 23 10.5 23 7.467 20.533 5 17.501 5z",
    opacity: 1,
    "data-original": "#009ada"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.612 23.75h-5.67a.972.972 0 0 1-.908-.578c.08.478.459.828.967.828h5.5a.5.5 0 0 0 .494-.418l.004-.028a.493.493 0 0 1-.387.196zM15.501 17.75h-1.534l-.043.25H15.5C19.636 18 23 14.636 23 10.5c0-.042-.005-.083-.006-.125-.068 4.078-3.4 7.375-7.493 7.375z",
    opacity: 1,
    fill: "#00000010",
    "data-original": "#00000010"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#273691",
    d: "M15.453 0H5.5c-.693 0-1.276.542-1.485 1.38-.03.12-3.014 18.037-3.015 18.707-.003.192-.008.455.203.67.21.214.507.243.798.243h4.28l1.062-7H12.5c4.695 0 8.513-3.826 8.5-8.524C20.99 2.442 18.486 0 15.452 0z",
    opacity: 1,
    "data-original": "#273691"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.45.25h10.044c2.405 0 4.474 1.508 5.259 3.622A5.557 5.557 0 0 0 15.453 0H5.5c-.693 0-1.276.542-1.485 1.38a8.314 8.314 0 0 0-.027.151C4.222.754 4.78.25 5.45.25z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.87 20.75c-.29 0-.588-.03-.798-.243-.015-.016-.022-.033-.035-.049a.658.658 0 0 0 .167.299c.21.214.507.243.798.243h4.28l.039-.25z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.344 14H12.5c4.44 0 8.09-3.422 8.463-7.767A5.47 5.47 0 0 0 17.501 5h-7.5c-.567 0-1.286.245-1.492 1.413z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M20.964 6.233c.022-.25.037-.502.036-.757C20.992 2.442 18.487 0 15.453 0H5.5c-.693 0-1.276.542-1.485 1.38-.03.12-3.014 18.037-3.015 18.707-.003.192-.008.455.203.67.21.214.507.243.798.243h4.28c-.171 1.158-.28 1.924-.28 2 0 .57.43 1 .999 1h5.5a.5.5 0 0 0 .494-.418l.93-5.582H15.5C19.636 18 23 14.636 23 10.5a5.49 5.49 0 0 0-2.036-4.267z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.5953a4d8d4eace3ae2b17ba6b1d8d631.svg";
export { ForwardRef as ReactComponent };